import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule, NoopAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { TaskBarComponent } from "./layout/mobile/task-bar/task-bar.component";
import { StoreModule } from "@ngrx/store";
import { userReducer } from "./state/reducer/user.reducer";
import { LoginComponent } from "./layout/components/login/login.component";
import { RegistrationComponent } from "./layout/components/registration/registration.component";
import { RecoveryComponent } from "./layout/components/recovery/recovery.component";
import localeDe from "@angular/common/locales/de";
import { registerLocaleData } from "@angular/common";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "src/environments/environment";
import { EffectsModule } from "@ngrx/effects";
import { AuthEffects } from "./state/effects/user-authentification.effects";
import { SharedModule } from "./shared/shared.module";
import { NotFoundComponent } from "./layout/components/not-found/not-found.component";
import { MaintenanceComponent } from "./layout/components/maintenance/maintenance.component";
import { VerificationComponent } from "./layout/components/verification/verification.component";
import { RecoveryConfirmationComponent } from "./layout/components/recovery-confirmation/recovery-confirmation.component";
import { PreloaderComponent } from "./layout/components/preloader/preloader.component";
import { HeaderComponent } from "./layout/mobile/header/header.component";
import { DefaultLayoutComponent } from "./layout/default-layout.component";
import { ActivitiesTabsComponent } from "./layout/mobile/header/tabs/activities-tabs/activities-tabs.component";
import { VouchersTabsComponent } from "./layout/mobile/header/tab-filters/vouchers-tabs/vouchers-tabs.component";
import { FreeToPlayTabsComponent } from "./layout/mobile/header/tab-filters/free-to-play-tabs/free-to-play-tabs.component";
import { HistoryTabsComponent } from "./layout/mobile/header/tab-filters/history-tabs/history-tabs.component";
import { buttonsReducer } from "./state/reducer/buttons.reducer";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, ReCaptchaV3Service } from "ng-recaptcha";
import { JackpotTabsComponent } from "./layout/mobile/header/tab-filters/jackpot-tabs/jackpot-tabs.component";
import { BettingTasksTabsComponent } from "./layout/mobile/header/tab-filters/betting-tasks-tabs/betting-tasks-tabs.component";
import { ShopTabsComponent } from "./layout/mobile/header/tab-filters/shop-tabs/shop-tabs.component";

registerLocaleData(localeDe);

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    HeaderComponent,
    ActivitiesTabsComponent,
    VouchersTabsComponent,
    FreeToPlayTabsComponent,
    HistoryTabsComponent,
    TaskBarComponent,
    LoginComponent,
    RegistrationComponent,
    RecoveryComponent,
    NotFoundComponent,
    MaintenanceComponent,
    VerificationComponent,
    RecoveryConfirmationComponent,
    PreloaderComponent,
    JackpotTabsComponent,
    BettingTasksTabsComponent,

    ShopTabsComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "de-DE" }, // number formating 9.99,00
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.siteKey },
    ReCaptchaV3Service
  ],
  bootstrap: [AppComponent],
  imports: [
    StoreModule.forRoot({ user: userReducer, buttons: buttonsReducer }),
    CommonModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    NoopAnimationsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    StoreDevtoolsModule.instrument({
      name: "NgRx Loyalty App Devtools",
      maxAge: 25,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([AuthEffects])
  ]
})

export class AppModule {

}